import { useState, useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { RegistrationContext } from '../../context/registration';

import {
    setContactPreference,
    fetchCampaignContext,
} from '~/services/registration';

import {
    Container,
    Button,
    Card,
    CardBody,
    Col,
    Row,
    Form,
    FormGroup,
    Input,
    Label,
} from 'reactstrap';

import { Loading } from '../../shared/components/Loading';

const communityOptions = [
    {
        label: 'Yes, I do',
        value: 'yes',
    },
    {
        label: "No, I don't",
        value: 'no',
    },
];

export const ContactPreference = ({}: any) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [{ campaignRequest }, registrationDispatch] =
        useContext(RegistrationContext);
    const [contactType, setContactType] = useState();
    const [timeOfDay, setTimeOfDay] = useState([]);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const { copy } = location.state;

    useEffect(() => {
        if (campaignRequest) {
            setLoading(false);
        } else {
            getCampaign();
        }
    }, []);

    const getCampaign = async () => {
        const resp = await fetchCampaignContext();
        console.log('resp: ', resp);

        registrationDispatch({
            type: 'set_registration',
            payload: resp,
        });
    };

    const handleNext = async () => {
        try {
            setSaving(true);
            const value =
                contactType === 'email'
                    ? campaignRequest.initial_email
                    : campaignRequest.initial_phone;
            const time_of_day =
                timeOfDay.length === 2 ? 'anytime' : timeOfDay[0];
            const payload = {
                type: contactType,
                value,
                time_of_day,
            };
            const resp = await setContactPreference(payload);
            console.log('resp: ', resp);
            setShowConfirmation(true);
        } catch (e) {
            setSaving(false);
            console.log('e: ', e);
        }
    };

    const handleTimeOfDay = (val) => {
        let newTimeOfDay = [];
        if (timeOfDay.includes(val)) {
            newTimeOfDay = timeOfDay.filter((x) => x !== val);
        } else {
            newTimeOfDay = [...timeOfDay, val];
        }
        setTimeOfDay(newTimeOfDay);
    };

    if (loading) {
        return <Loading />;
    }

    const disableNext = timeOfDay.length === 0 || !contactType;

    return (
        <Container>
            <Row className='justify-content-center py-5'>
                <Col md='6'>
                    <div className='text-center'>
                        <h3>{copy.header}</h3>
                        <p>{copy.description}</p>
                    </div>{' '}
                    {showConfirmation ? (
                        <Card
                            className='box-shadow my-5'
                            style={{
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                        >
                            <CardBody>
                                <h4>Thanks! Someone will be in touch.</h4>
                                <p>We'll be in touch within 24-48 hours.</p>
                            </CardBody>
                        </Card>
                    ) : (
                        <div>
                            <Form>
                                <Card
                                    className='box-shadow my-5'
                                    style={{
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                    }}
                                >
                                    <CardBody>
                                        <h4>
                                            What's the best way to reach you?
                                        </h4>
                                        <FormGroup check className='mb-3'>
                                            <Row>
                                                <Col>
                                                    <Label check>
                                                        <Input
                                                            type='radio'
                                                            value='email'
                                                            onClick={() =>
                                                                setContactType(
                                                                    'email'
                                                                )
                                                            }
                                                            name='contact_type'
                                                        />
                                                        Email (
                                                        {
                                                            campaignRequest.initial_email
                                                        }
                                                        )
                                                    </Label>
                                                </Col>
                                                <Col>
                                                    <Label check>
                                                        <Input
                                                            type='radio'
                                                            value='phone'
                                                            onClick={() =>
                                                                setContactType(
                                                                    'phone'
                                                                )
                                                            }
                                                            name='contact_type'
                                                        />
                                                        Phone (
                                                        {
                                                            campaignRequest.initial_phone
                                                        }
                                                        )
                                                    </Label>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <p>
                                            We're available Mon-Fri 9 AM-6 PM
                                            ET. When would be the best time to
                                            contact you?
                                        </p>
                                        <FormGroup check className='mb-3'>
                                            <Row>
                                                <Col>
                                                    <Label check>
                                                        <Input
                                                            type='checkbox'
                                                            value='morning'
                                                            onClick={() =>
                                                                handleTimeOfDay(
                                                                    'email'
                                                                )
                                                            }
                                                            name='time_of_day'
                                                        />
                                                        Morning
                                                    </Label>
                                                </Col>
                                                <Col>
                                                    <Label check>
                                                        <Input
                                                            type='checkbox'
                                                            value='afternoone'
                                                            onClick={() =>
                                                                handleTimeOfDay(
                                                                    'phone'
                                                                )
                                                            }
                                                            name='time_of_day'
                                                        />
                                                        Afternoon
                                                    </Label>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </CardBody>
                                </Card>

                                <div className='text-center'>
                                    <Button
                                        color='primary'
                                        onClick={handleNext}
                                        disabled={saving || disableNext}
                                    >
                                        {saving ? `Saving...` : `Next`}
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    );
};
